import { Button, Card, Col, Row, Skeleton } from 'antd';
import React, { ReactElement, useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormSelect, FormTextInput } from '../../../../../../../shared/components/crmFormElement/FormInput';
import {
  GUTTOR_SPACE,
  ROOM_RENT_WITH_ADDITIONAL_FIELD_WARNING,
  TYPEAHED_SEARCH_STRING_MIN_LENGTH,
  AUTOMATION_SIMULATION_MEMBER_ID,
  AUTOMATION_SIMULATION_PAYER,
  AUTOMATION_SIMULATION_HOSPITAL,
  PROD_AUTOMATION_SIMULATION,
  PANCARD_REGEX_NEW,
  DEFAULT_BILL_DETAILS_TEXT,
} from '../../../../../../../shared/constants/commonConstants';
import { actions, BILL_DETAIL, BILL_DETAIL_EMAIL, BILL_DETAIL_HDFC, BILL_PACKAGE_NAME, DIALYSIS_BILL_DETAIL_TEXT, RPA_BILL_DETAIL,
  NON_NUMERIC_REGEX,
  VALUE_NOT_UPDATED,
  ATLEAST_ONE_BILL_ITEM_MESSAGE} from '../../../../../../../shared/constants/crmConstants';
import { RootState } from '../../../../../../../store';
import { fetchPackage } from '../../../../../../../store/actions/lookUpAction';
import {
  billAmountGT0Validation, getIsPageNameDetail, getIsPageNameEdit, getIsPageNameEditDischarge,  getIsPageNameNewAdmission,
  getLookUpFullDetail, getNoOfDays, panValidationUploadBill,  billMaxAmtValidation, getIsPageNameReconsider,
  handleUserFocus,
  formatAmount,
  getBillTotal,
  processHISBillData,
  disableHISPopulatedFields,
  createBillPackageIndexMap,
} from '../../../../service/crmUtils';
import CustomPackageOption from '../CustomPackageOption/CustomPackageOption';
import ClaimDetailHeader from '../ClaimDetailHeader/ClaimDetailHeader';
import {
  updatePackageSelection, updateAdditionalMandatoryDocuments, setPanRequired, setPanVerificationRequired,
  setPayerRoomType, setBillDetailVal, setHospitalOtherRoomType, setsubmitDisabled,
  getpanVerification, setSuccessModal, setPanVerified, setPanField,
} from '../../../../../../../store/actions/newAdmissionAction';
import { setTotalAmount } from '../../../../../../../store/actions/nhcxAction';
import { cloneDeep, intersection, intersectionWith, isEmpty, uniqBy } from 'lodash';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { getTotalSum } from '../../../../../../../utils/setClaimDetailInFormUtils';
import { AdmissionContext } from '../../../AdmissionContext';
import FormFormattedAmount from '../../../../../../../shared/components/crmFormElement/FormFormattedAmount/FormFormattedAmount';
import NumberFormatView from '../../../../../../../shared/components/NumberFormatView/NumberFormatView';
import FormCheckboxGroup from '../../../../../../../shared/components/crmFormElement/FormCheckBoxGroup/FormCheckboxGroup';
import ApplicationDetail from '../../../../../../../shared/services/applicationDetail.service';
import PackageRadioButton from '../../../../../../../shared/components/crmFormElement/PackageRadioButton/PackageRadioButton';
import FormSelectBill from '../../../../../../../shared/components/crmFormElement/FormSelect/FormSelectBill';
import { centeredNotification, isDigitizationFeatureEnabled } from '../../../../../../../utils/utility';
import { ApplicationDetailModel } from '../../../../../../../store/models/applicationDetailModel';
import VerificationSuccessModal from '../CustomerDetailCard/OTPSucessModal';
import { NewAdmissionState } from '../../../../../../../store/models/newAdmissionModel';
import { EditOutlined } from '@ant-design/icons';
import BillDetailsFieldsMap from '../../../../../../../config/BillDetailsFields.json';
import PanelCollapse from '../../../../../../../shared/components/collapse/PanelCollapse';
import ConsentPanel from '../../cardPanels/ConsentPanel';
import './BillDetail.less';
import { setIsHISPackageFilled, setSuggestedValuesMap } from '../../../../../../../store/actions/hospitalAction';

const BillDetailCard = ({
  form,
  isLoading,
  location: { pathname },
}: any): ReactElement => {
  const {
    admissionDetails: { claimDetails: claimDetail, claimDetails: { dialysis: dialysisObj = {} } = {} },
    newAdmission: { admissionFormVal: {
      treatmentDetail: { dialysis: dialysisTreatmentDetail = '', dateOfAdmission, dateOfDischarge,
        hospitalRoomType: roomType }, billDetail: billsdetail,

    },
      additionalMandatoryDocuments,
      isDraftSelected,
      autoSimulationpackages,
      selectedPackage,
      hospitalOtherRoomType,
      billdetailValues,
    },
    payerList: { payer: { uniqueIdentifier, isRpaPayer, shortName, name, featuresEnabled }, formControlConfig },
    payerLookUp,
    nhcx: { coverageResponse },
  } = useSelector((state: RootState): RootState => state);
  const payerConfigValuesObj = Object.values(formControlConfig);
  const { panVerified }: any = useSelector((state: RootState):
    NewAdmissionState => state.newAdmission);
  const { dialysis: dialysisClaimDetail } = dialysisObj || {};
  const collapsibleBillSection = payerConfigValuesObj?.some(({ type, hidden }: any): boolean =>
    type === 'COLLAPSIBLE_BILL_SECTION' && !hidden) ?? false;
  const BILLDETAILS = (shortName === 'HDFC' && process.env.REACT_APP_HDFC_FEATURES === 'true') ? BILL_DETAIL_HDFC :
  collapsibleBillSection ? BILL_DETAIL_EMAIL : BILL_DETAIL;
  const [billDetail, setBillDetail] = useState<any>(cloneDeep(isRpaPayer ? RPA_BILL_DETAIL :  BILLDETAILS));
  const dispatch = useDispatch();

  useSmoothScroll('bill-scroll');
  const [packageList, setPackageList] = useState<any[]>([]);
  const [total, setTotal] = useState<any>(0);
  const [isPackageLoading, setIsPackageLoading] = useState<boolean>(false);
  const [pkgSearchType, setPkgSearchType] = useState(null as any);
  const [pkgTypeLoading, setPkgTypeLoading] = useState(false);
  const [allowedRent, setAllowedRent] = useState(null as any);
  const [isAdditionalFieldNeeded, setIsAdditionalFieldNeeded] = useState(false);
  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const [isPackageSelectionUpdated, setIsPackageSelectionUpdated] = useState(false);
  const [packageFieldValue, setPackageFieldValue] = useState<any>(null);
  const { nextAllowStatus } = claimDetail || {};
  const { claimDetailBackup } = useContext(AdmissionContext);
  const [dialysisVal, setDialysisVal] = useState(0);
  const newAsmissionData = form.getFieldsValue(true);
  const [isDropDown, setDropDown] = useState(false);
  const [billDetailData, setBillDetailData] = useState<any>({});
  const [eitherOrRequired, setEitherOrRequired] = useState<boolean>(false);
  const [thresholdAmount, setThresholdAmount] = useState(0);
  const [verificationAmount, setVerificationAmount] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [verificationForPanRequired, setVerificationForPanRequired] = useState(false);
  const { memberId, payer, policyNumber } = newAsmissionData;
  const [isPanNumberLoading, setIsPanNumbeLoading] = useState(false);
  const [buttonName, setButtonName] = useState('');
  const [statesForPan, setStatesForPan] = useState([]);
  const [isPanVisibleAlways, setIsPanVisibleAlways] = useState(false);
  const isAllTimeRequired = (Boolean(payerConfigValuesObj?.filter(({ type, hidden }: any): boolean =>
    (type === 'allTimeRequired' && !hidden))?.length));
  const [isBillItemsNotRequired, setBillItemsNotRequired] = useState(false);
  const appdetails = useSelector(
    (state: RootState): ApplicationDetailModel => state.applicationDetail,
  );
  const isEditPage = getIsPageNameEdit(pathname);
  const isEditDischargePage = getIsPageNameEditDischarge(pathname);
  const isEditReconsider = getIsPageNameReconsider(pathname);
  const appService = ApplicationDetail.instance;
  const billsdetailFieldsName = Object.keys(billsdetail);
  const isFieldUndefined = billsdetailFieldsName?.every((ele: any): boolean => {
    return (!form.getFieldsValue()[ele]);
  });
  const isNHCXEnabledProvider = ApplicationDetail.instance.getIsNHCXEnabledProvider();
  const billDetailNew = BILLDETAILS.concat(RPA_BILL_DETAIL);
  const isDetailPage = getIsPageNameDetail(pathname);
  const [status] = nextAllowStatus || '';
  const checkIfPOIEnabled = (): boolean => (appdetails.getIsPOIEnabledForHospital());
  const { selectedPatientDetail, isHISPackageFilled, suggestedValuesMap } = useSelector((state: RootState): any => state?.hospital);
  const commonDetail = { isLoading, form, claimDetailBackup };
  const [inputStates, setInputStates] = useState<Record<string, { isShowSuggestedValue: boolean }>>({});
  const [isPanelExpanded, setIsPanelExpanded] = useState(0);
  const [panFromHIS, setPanFromHIS] = useState('');
  const isMinValidationRequired = payerConfigValuesObj?.filter(({ type }: any): boolean => type === 'minValidtaionRequired');
  const minClaimedAmountValidtaionObject = isMinValidationRequired[0];
  const minClaimedAmountRequired = minClaimedAmountValidtaionObject?.['minClaimedAmount'];
  const isEditable = isNewAdmissionPage || isEditPage || isEditDischargePage || isEditReconsider;
  const isPatientSignEnabled = ApplicationDetail.instance.getIsPatientSignEnabled();
  const isPackageEnabled = featuresEnabled?.['isPackageEnabled'];
  const GO_DIGIT_PAYER = payerConfigValuesObj?.some(({ options, hidden }: any): boolean =>
    options === 'GO_DIGIT_MATERNITY_TYPE_OPTIONS' && !hidden) ?? false;
  const disableOnDischargeEnabled = payerConfigValuesObj?.some(({ disableOnDischarge }:
    { disableOnDischarge?: boolean }): boolean => disableOnDischarge ?? false) ?? false;
  const isDischargeFlow = (status === actions.DISCHARGE || isEditDischargePage);
  const billAmountInstructionText =
    isDischargeFlow && formControlConfig?.billDetailsConfigs?.dischargeText && formControlConfig.billDetailsConfigs?.disableOnDischarge
      ? formControlConfig.billDetailsConfigs.dischargeText
      : DEFAULT_BILL_DETAILS_TEXT;
  const shouldAutoFill = !(disableOnDischargeEnabled && (isEditDischargePage || status === actions.DISCHARGE));

  useEffect((): void => {
    const patientBillDetails = selectedPatientDetail?.billDetails;
    const billDetailsFieldKeys = Object.keys(form?.getFieldsValue());
    if (shouldAutoFill && !isEmpty(patientBillDetails)) {
      // loops through HIS Bill details and tries to find a field name from BillDetailsFields.json that matches the form field name
      Object?.entries(patientBillDetails)?.forEach(([key, value]: any): void => {
        if (BillDetailsFieldsMap.hasOwnProperty(key)) {
          BillDetailsFieldsMap[key]?.forEach((ele: string): void => {
            if (billDetailsFieldKeys.includes(ele)) {
              if ((ele === 'Investigation' && shortName === 'SHAI' && isRpaPayer) || value === 0) {
                return;
              }
              form.setFieldsValue({
                [ele]: value,
              });
            }
          });
        }
      });
    }
    if (!isDetailPage) {
      setRequiredField();
    }
    const { searchPackage } = form.getFieldsValue(['searchPackage']);
    const draft_searchPackage = billsdetail?.searchPackage;
    if (searchPackage?.length || draft_searchPackage)  {
      setPackageList(selectedPackage);
    } else if (process.env.REACT_APP_IS_ENABLED_AUTOMATION_SIMULATION === 'true') {
      if (
        (
          Number(appService.getProviderId()) === Number(AUTOMATION_SIMULATION_HOSPITAL) &&
          memberId === AUTOMATION_SIMULATION_MEMBER_ID
        ) ||
        (
          PROD_AUTOMATION_SIMULATION?.HOSPITALS?.includes(Number(appService.getProviderId())) &&
          (
            memberId === PROD_AUTOMATION_SIMULATION?.MEMBER_ID ||
            policyNumber === PROD_AUTOMATION_SIMULATION?.POLICY_NO
          )
        )
      ) {
        setPackageList(autoSimulationpackages);
      }
    } else if (
      intersection(
        [actions.DISCHARGE, actions.ENHANCEMENT],
        nextAllowStatus,
      ).length ||
      isNewAdmissionPage
    ) {
      setPackageList([]);
    } else {
      setPackageList([]);
    }
    calculateForm();
    if (!isAllTimeRequired) {
      if ((form?.getFieldsValue()).Package) {
        billDetail.map((ele: any): any => ele.isRequired = false);
        billDetail[0].isRequired = true;
      }
    }

    const billDetails: any = {};
    if (payerLookUp[uniqueIdentifier]) { // fix for billdetails blank page when claim detail doesnt have values

      billDetail?.map((ele: any): any => {
        const billDataArr = payerLookUp[uniqueIdentifier][ele?.billDropDownName] ?
          payerLookUp[uniqueIdentifier][ele?.billDropDownName] : [];
        const billdataObj: any = {};
        billDataArr?.map((element: any): any => {
          billdataObj[element?.payerMasterValue] = element?.additional;
        });
        if (hospitalOtherRoomType && (ele?.billDropDownName === 'Room_rent_Nursing_charges')) {
          billdataObj[hospitalOtherRoomType] = undefined;
        }
        billDetails[ele?.billDropDownName] = billdataObj;
      });
    }
    dispatch(setBillDetailVal(billDetails['Room_rent_Nursing_charges']));
    setBillDetailData(billDetails);
    if (billsdetail?.Package) {
      updatePackageValue(billsdetail?.Package, 'Package');
    }
  }, []);

  useEffect((): any => {
    if (GO_DIGIT_PAYER) {
      total === 0
        ? dispatch(setsubmitDisabled(true))
        : dispatch(setsubmitDisabled(false));
    } else {
      if (isEmpty(selectedPackage)) {
        setTimeout((): any => {
          form
            ?.validateFields()
            .then((): any => {
              dispatch(setsubmitDisabled(false));
            })
            .catch((): any => {
              // to disable submit button till the fields are filled
              dispatch(setsubmitDisabled(true));
            });
        }, 1000);
      } else {
        dispatch(setsubmitDisabled(false));
      }
    }
  }, [selectedPackage, total]);

  useEffect((): void => {
    billsdetailFieldsName?.map((ele: any): void => {
      if (billsdetail[ele] && form.getFieldsValue()[ele] === undefined && isFieldUndefined) {
        form.setFieldsValue({
          [ele]: billsdetail[ele],
        });
      }
    });
    calculateForm();
  }, [isFieldUndefined]);

  useEffect((): void => {
    if (status !== 'DISCHARGE') {
      if (total >= 100000) {
        dispatch(setPanRequired(true));
      } else {
        dispatch(setPanRequired(false));
      }
    }
    if (!isVisible) {
      if (total > thresholdAmount) {
        setIsVisible(true);
      }
    }
    // TODO: Static as of now if mandatoryClassification has some entry and new admission
    if (getIsPageNameNewAdmission(pathname) && payerLookUp[uniqueIdentifier]?.mandatoryClassificationName?.length) {
      if (total > 100000 && !additionalMandatoryDocuments?.includes('pan')) {
        dispatch(updateAdditionalMandatoryDocuments([...additionalMandatoryDocuments, 'pan']));
      } else {
        dispatch(updateAdditionalMandatoryDocuments((additionalMandatoryDocuments || [])?.filter((items: any): any => items !== 'pan')));
      }
    }
    if (isNHCXEnabledProvider && !isEmpty(coverageResponse)) {
      dispatch(setTotalAmount(total));
    }
  }, [total]);
  useEffect((): void => {
    const payerConfigValues = Object.values(formControlConfig);
    const isPresent = payerConfigValues.filter(({type}: any): any => type === 'Bill Dropdown');
    isPresent.length > 0 ? setDropDown(true) : setDropDown(false);
    setEitherOrRequired(Boolean(payerConfigValues?.filter(({ eitherRoomRentOrICUChargesRequired }: any): any =>
      eitherRoomRentOrICUChargesRequired)?.length));
    const isPanRequired = payerConfigValues?.filter(({type, hidden}: any): boolean => (type === 'PanCardFieldPresentBill' && !hidden));
    const thresholdAmountForPan = isPanRequired?.map((ele: any): any => ele['reqAmount'])[0];
    const verificationAmountForPan = isPanRequired?.map((ele: any): any => ele['verAmount'])[0];
    const isPanVisbile = isPanRequired?.map((ele: any): any => ele['isPanVisbileAlways'])[0];
    setIsPanVisibleAlways(isPanVisbile);
    const statusForPanRequired = isPanRequired?.map((ele: any): any => ele['statusForPanRequired'])[0];
    const verificationRequired = isPanRequired?.map((ele: any): any => ele['verificationRequired'])[0];
    setThresholdAmount(thresholdAmountForPan);
    setVerificationAmount(verificationAmountForPan);
    setStatesForPan(statusForPanRequired);
    setVerificationForPanRequired(verificationRequired);
    setBillItemsNotRequired(Boolean(payerConfigValues?.filter(({ type, hidden }: any): boolean =>
      (type === 'billItemsNotRequired' && !hidden))?.length));
  }, []);

  useEffect((): any => {
    if (panVerified) {
      setButtonName('Verified');
    } else {
      setButtonName('Verify');
    }

  }, [panVerified]);

  useEffect((): any => { // for star - billdetail and room type mapping
    if (!isDetailPage && hospitalOtherRoomType && isDropDown) {
      form?.setFieldsValue({ Room_rent_Nursing_charges: hospitalOtherRoomType });
      onSelect(hospitalOtherRoomType);
      dispatch(setPayerRoomType(hospitalOtherRoomType));
      form?.setFieldsValue({ payerRoomType: hospitalOtherRoomType });
    }
  }, [hospitalOtherRoomType, billdetailValues]);

  useEffect((): void => {
    const dialysis = isDetailPage ? dialysisClaimDetail : dialysisTreatmentDetail;
    if (dialysis || (dateOfAdmission && dateOfDischarge)) {
      if (dialysis) {
        setDialysisVal(parseInt(dialysis, 10));
      }
      const sum = getTotalSum(selectedPackage, dateOfAdmission, dateOfDischarge, dialysis);
      // changed the function to calculate sum based on package selected and number of dialysis
      // sessions if package is related to dialysis
      if (form.getFieldValue(BILLDETAILS[0].billPackageName) && dialysis && selectedPackage?.length > 0) {
        setTimeout((): void => {
          form.setFieldsValue({
            [BILLDETAILS[0].billPackageName]: sum,
          });
          billDetail[0].dialysis = !!dialysis;
          setBillDetail(cloneDeep(billDetail));
          const billInfo = form.getFieldsValue(BILL_PACKAGE_NAME(isRpaPayer, shortName));
          calculateTotal(billInfo);
        }, 100);
      } else if (!isEmpty(billsdetail)) {
        const billInfo = form.getFieldsValue(BILL_PACKAGE_NAME(isRpaPayer, shortName));  // total based on field values
        billInfo && calculateTotal(billInfo);
      }
    } else {
      billDetail[0].dialysis = false;
      setBillDetail(cloneDeep(billDetail));
      const billInfo = form.getFieldsValue(BILL_PACKAGE_NAME(isRpaPayer, shortName));
      calculateTotal(billInfo);
    }
  }, [dialysisTreatmentDetail, dialysisClaimDetail, dateOfAdmission, dateOfDischarge]);

  useEffect((): void => {
    if (isDraftSelected) {
      const packageData = form.getFieldsValue(['Package']);

      if (
        packageData?.Package?.length > 0 ||
        billsdetail?.Package?.length > 0
      ) {
        if (!isAllTimeRequired) {
          setPackageAsRequiredField();
        }
      }

      const isPackageSelected = billsdetail?.Package?.length > 0;
      if (isPackageSelected && !isAllTimeRequired) {
        billDetail[0].isRequired = isPackageSelected;
        billDetail[1].isRequired = !isPackageSelected;
        }

      packageList?.map((p: any): void => {
        const hasPackageSelected = form.getFieldsValue([`${p?.packageId}`])?.[`${p?.packageId}`];
        if (hasPackageSelected) {
          setPackageAsRequiredField();
        }
      });
    }
  }, [isDraftSelected, packageList]);

  const setPackageAsRequiredField = (): void => {
    const billDetailClone = cloneDeep(billDetail);
    billDetailClone[0].isRequired = true;
    billDetailClone[1].isRequired = false;
    setBillDetail(billDetailClone);
  };
  const hasProcessedHisData = useRef(false);
  const HISBillDetails = selectedPatientDetail?.billDetails || {};
  const billTotal = getBillTotal(HISBillDetails);
  const formattedTotal = HISBillDetails
    ? billTotal !== null
      ? formatAmount(billTotal)
      : VALUE_NOT_UPDATED
    : undefined;

  const setRequiredField = (): void => {
    const billDetailClone = cloneDeep(billDetail);
    const packageVal = form.getFieldsValue()[BILLDETAILS[0].billPackageName];
    const isRequired = parseInt(String(packageVal)?.replace(/[₹ ,]/g, ''), 10) > 0;
    if (!isAllTimeRequired) {
      billDetailClone[1].isRequired = !isRequired;
      billDetailClone[0].isRequired = isRequired;
      setBillDetail(billDetailClone);
    }
  };

  const calculateForm = (): void => {
    const formValues = form.getFieldsValue(BILLDETAILS.map(({ billPackageName }: any): string => billPackageName)) || {};
    setRequiredField();
    calculateTotal(formValues);
  };

  const onInitialPkgSearchSuccess = (response: any): any => {
    setPackageList(response);
    setPkgSearchType(appService.getIsNewAutomationEnabled() ? 'RADIO' : 'CHECKBOX');
    setPkgTypeLoading(false);
  };

  const onInitialPkgSearchFailure = (): any => {
    if (
      process.env.REACT_APP_IS_ENABLED_AUTOMATION_SIMULATION !== 'true' &&
      memberId !== AUTOMATION_SIMULATION_MEMBER_ID
    ) {
      setPackageList([]);
    }
    setPkgSearchType('SEARCH');
    setPkgTypeLoading(false);
  };

  useEffect((): any => {
    billDetail[0]['disabled'] = !!(selectedPackage?.length);
    setRequiredField();
    setDisabledField();
    setBillDetail(cloneDeep(billDetail));
  }, [nextAllowStatus, selectedPackage]);

  useEffect((): any => {
    if (!isDetailPage) {
      if (isPackageEnabled) {
        setPkgTypeLoading(true);
        dispatch(fetchPackage('', onInitialPkgSearchSuccess, onInitialPkgSearchFailure));
      }
    }
  }, []);
  // for drafts and on change of tab - bill detail fix
  useEffect((): any => {
    if (isDropDown) {
      billDetail?.map((ele: any): any => {
        const packageName = ele?.billPackageName;
        billDetailDropdownReq(form?.getFieldValue(ele?.billPackageName), packageName);
      });
    }
  }, [isDropDown]);

  useEffect((): any => {
    if (verificationForPanRequired && verificationAmount) {
      if (total > verificationAmount) {
        dispatch(setPanVerificationRequired(true));
      } else {
        dispatch(setPanVerificationRequired(false));
      }
    }
  }, [total]);

  let billItemAmount = 0;

  const onSelect = (target: any, key?: any): void => {
    if (key !== undefined) {
      const billItem = key['data-testname'] || '';
      const billDropDownItem = key['data-dropdown'] || '';
      const field = billDetailData[billDropDownItem];
      billItemAmount = field[target];
      form.resetFields([billItem]);
      form.setFieldsValue(
        {
          [billItem]: billItemAmount,
        });
      dispatch(setHospitalOtherRoomType(form?.getFieldsValue('Room_rent_Nursing_charges')?.Room_rent_Nursing_charges));
      updatePackageValueDrop(target, billDropDownItem);
    } else { // for star room type and bill detail mapping and setting the charges
      if (target !== undefined && billdetailValues?.length) {
        const billItem = 'Room rent & Nursing charges';
        const billDropDownItem = 'Room_rent_Nursing_charges';
        billItemAmount = billdetailValues[target];
        form?.resetFields([billItem]);
        form?.setFieldsValue(
          {
            [billItem]: billItemAmount,
          });
        updatePackageValueDrop(target, billDropDownItem);
      }
    }
  };

  const makeRoomRentOrICURequired = (selectedValue: any, billName: string): any => {
    if (billName === BILL_DETAIL[1].billDropDownName || billName === BILL_DETAIL[1].billPackageName) {
      const elementToUpdate = billDetail?.find((ele: any): any => ele?.billDropDownName === 'ICU_Charges');
      if (elementToUpdate) {
        elementToUpdate.isRequired = !Boolean(selectedValue);
        billDetail[1].isRequired = Boolean(selectedValue);
      }
    }
    if (billName === 'ICU_Charges' || billName === 'ICU Charges') {
      const elementToUpdate = billDetail?.find((ele: any): any => ele?.billDropDownName === 'ICU_Charges');
      if (elementToUpdate) {
        elementToUpdate.isRequired = Boolean(selectedValue);
        billDetail[1].isRequired = !Boolean(selectedValue);
      }
    }
  };

  const updatePackageValueDrop = (selectedValue: string, billName: string): void => {
    if (billName === BILLDETAILS[0].billDropDownName && !isAllTimeRequired) {
      billDetail.map((ele: any): any => {
        if (ele?.billDropDownName !== 'Package_charges') {
          if (selectedValue) {
            ele.isRequired = eitherOrRequired && (ele?.billDropDownName === 'Room_rent_Nursing_charges' || ele?.billDropDownName === 'ICU_Charges') ? ele.isRequired : !selectedValue;
            billDetail[0].isRequired = selectedValue;
          } else {
            ele['isRequired'] = undefined;
            billDetail[0].isRequired = selectedValue;
          }
        }
      });
    }
    if (eitherOrRequired) { // For payer where ICU Charges become option when room rent is entered (as of now For NIVA BUPA)
      makeRoomRentOrICURequired(selectedValue, billName);
    }
    billDetail.map((ele: any): any => {
      if (!Array.isArray(form.getFieldValue(ele.billDropDownName)) || form.getFieldValue(ele.billDropdownName !== null)) {
        if (form.getFieldValue(ele.billPackageName) === null) {
          ele['isRequired'] = true;
          dispatch(setsubmitDisabled(ele['isRequired']));

        }
      }
    });
    billDetailNew.map((ele: any): any => {
      if (ele.billDropDownName === billName) {
        ele['billLevel3CategoryName'] = selectedValue?.concat(',', ele.billDropDownName);
      }
    });
    form.validateFields();
    const billInfo = form.getFieldsValue(BILL_PACKAGE_NAME(isRpaPayer, shortName));
    calculateTotal(billInfo);
    setBillDetail(cloneDeep(billDetail));
  };

  const updatePackageValue = (textValue: string, billName: string): void => {
    if (billName === BILLDETAILS[0].billPackageName && !isAllTimeRequired) {
      billDetail?.map((ele: any): any => {
        if (ele?.billPackageName !== 'Package') {
          if (textValue !== null) {
            if (textValue) {
              ele.isRequired = eitherOrRequired && (ele?.billDropDownName === 'Room_rent_Nursing_charges' || ele?.billDropDownName === 'ICU_Charges') ? ele.isRequired : !textValue;
              billDetail[0].isRequired = textValue;
            } else {
              ele['isRequired'] = eitherOrRequired && (ele?.billDropDownName === 'Room_rent_Nursing_charges' || ele?.billDropDownName === 'ICU_Charges') ? ele.isRequired : undefined;
              billDetail[0].isRequired = textValue;
            }
          }
        }
      });
    }
    if (eitherOrRequired) { // For payer where ICU Charges become option when room rent is entered (as of now For NIVA BUPA)
      makeRoomRentOrICURequired(textValue, billName);
    }
    if (isDropDown) {
      billDetailNew.map((ele: any): any => {
        if (ele.billPackageName === billName) {
          const selectedValue = form?.getFieldsValue(ele?.billDropDownName)?.[ele?.billDropDownName];
          ele['billLevel3CategoryName'] = `${selectedValue},${ele?.billDropDownName}`;  // billdetails prod issue bugfixed
        }
      });
      // fix for bill detail dropdown values
      billDetailDropdownReq(textValue, billName);
    }
    if (billName === BILLDETAILS[1].billPackageName) {
      if (roomType && dateOfAdmission && dateOfDischarge) {
        const [selectedRoom] = getLookUpFullDetail([roomType], payerLookUp[uniqueIdentifier]?.providerRoomType, true, false) || [];
        if (selectedRoom) {
          const allowedRoomRent = getNoOfDays(dateOfAdmission, dateOfDischarge) * selectedRoom?.roomRent;
          setAllowedRent(allowedRoomRent);
          if (allowedRoomRent < parseInt(textValue?.replace(/[₹ ,]/g, ''), 10)) {
            billDetail[1].amountNotAllowed = true;
          } else {
            billDetail[1].amountNotAllowed = false;
          }
        }
      }
    }
    form.validateFields();
    setIsAdditionalFieldNeeded(false);
    const billInfo = form.getFieldsValue(BILL_PACKAGE_NAME(isRpaPayer, shortName));
    calculateTotal(billInfo);
    checkIfMoreDataRequired(billInfo);
    setBillDetail(cloneDeep(billDetail));
  };

  const onChange = ({
    target: { value: textValue } = { value: 0 } }: any,
    billName: string,
  ): void => {
    // Track user interaction with package field
    if (billName === 'Package') {
      setPackageFieldValue(textValue); // Update package field state to trigger total recalculation
    }
    updatePackageValue(textValue, billName);
  };

  const onSuccess = (response: any): any => {
    setIsPackageLoading(false);
    setPackageList(response);
  };

  const onError = (): any => {
    setIsPackageLoading(false);
  };

  const checkIfMoreDataRequired = (billInfo: any): void => {
    const values = Object.values(billInfo);
    const [rentVal] = values.splice(1, 1);
    if (rentVal) {
      const otherValues = values.filter((ele: any): boolean => ele);
      if (!otherValues.length) {
        setIsAdditionalFieldNeeded(true);
      } else {
        setIsAdditionalFieldNeeded(false);
      }
    }
  };
  const setDisabledField = (): void => {
    // Check for disableBillOnDischarge config
    // Determine if current flow is discharge or discharge draft
    // Disable all bill items if config is set and flow is discharge/discharge draft
    if (disableOnDischargeEnabled && isDischargeFlow && billDetail) {
      billDetail.forEach((ele: any): void => {
        ele.disabled = true;
      });
    }
  };

  const calculateTotal = (billInfo: any): void => {
    if (billInfo) {
      const totalAmt = Object.values(billInfo)
        .filter((ele: any): boolean => (String(ele)?.split('-')?.length <= 1))
        .reduce((totalAmount: number, value: any): number => {
          if (typeof value === 'string') {
            value = value.replace(/[₹ ,]/g, '');
            const parsedValue = parseFloat(value);
            return totalAmount + (isNaN(parsedValue) ? 0 : parsedValue);
          } else if (typeof value === 'number') {
            return totalAmount + value;
          }
          return totalAmount;
        }, 0);
      setTotal(totalAmt);
    }
  };
  // function for bill detail dropdown and package name star ipp-4126
  const billDetailDropdownReq = (textValue: string, billName: string): void => {
    billDetail?.map((ele: any): any => {
      const billPackage = ele?.billPackageName;
      if (billPackage === billName) {
        if (form?.getFieldValue(ele?.billDropDownName) === null || form?.getFieldValue(ele?.billDropDownName) === undefined) {
          ele['isRequired'] = (textValue && billName) ? true :
            (ele?.billDropDownName !== 'Package_charges' && ele?.billDropDownName === 'Room_rent_Nursing_charges' && !eitherOrRequired) ?
              true : false;
        }
      }
    });
    setBillDetail(cloneDeep(billDetail));
  };
  const packageSearch = (event: any): any => {
    if (event?.length >= TYPEAHED_SEARCH_STRING_MIN_LENGTH) {
      if (isPackageEnabled) {
        setIsPackageLoading(true);
        dispatch(fetchPackage(event, onSuccess, onError, true ));
      }
    }
  };

  const packageChangeHandler = (event: any[]): any => {
    const concatedPackageList = packageList.concat((selectedPackage || []));
    const selectedPackageDetail = intersectionWith(
      concatedPackageList, event, ({ value }: any, pkgId: number): boolean => value === pkgId,
    );
    const sum = getTotalSum(selectedPackageDetail, dateOfAdmission, dateOfDischarge, dialysisVal);
    // changed the function to calculate sum
    if (isEmpty(event)) {
      delete billsdetail?.Package; // sessions if package is related to dialysis
      form?.resetFields(['Package']);
      setPackageFieldValue(''); // Update state to trigger total recalculation
    } else {
      form.setFieldsValue({                           // based on package selected and number of dialysis
        [BILLDETAILS[0].billPackageName]: sum,       // sessions if package is related to dialysis
      });
      setPackageFieldValue(sum); // Update state to trigger total recalculation
    }
    billDetail[0].dialysis = !!dialysisVal;
    setBillDetail(cloneDeep(billDetail));
    updatePackageValue(sum, 'Package');

    const billInfo = form.getFieldsValue(BILL_PACKAGE_NAME(isRpaPayer, shortName));
    calculateTotal(billInfo);
    dispatch(updatePackageSelection(selectedPackageDetail));
    if (
      process.env.REACT_APP_IS_ENABLED_AUTOMATION_SIMULATION !== 'true' &&
      memberId !== AUTOMATION_SIMULATION_MEMBER_ID
    ) {
      setPackageList(pkgSearchType === 'CHECKBOX' ? uniqBy(concatedPackageList, 'packageId') : selectedPackageDetail);
    }
  };

  const getNotAllowedAmount = (): ReactElement => {
    return (
      <span>
        Room rent charges for this case is in the range {<NumberFormatView amount={0} prefix={'₹ '} fixedDecimalScale={true} />} -
        {<NumberFormatView amount={allowedRent} prefix={'₹ '} fixedDecimalScale={true} />},
        please modify the changes to avoid delays in claim processing.
      </span>
    );
  };

  const changeToUpper = (): void => {
    form.setFields([
      {
        name: 'kycPanBill',
        value: form?.getFieldValue('kycPanBill').toUpperCase(),
      },
    ]);
    dispatch( setPanField(form?.getFieldValue('kycPanBill')));
    dispatch(setPanVerified(false));
    setTimeout((): any => {
      if (!(verificationForPanRequired)) {
        form?.validateFields().then((): any => {
          dispatch(setsubmitDisabled(false));
        }).catch((): any => {  // to disable submit button till the Pan Field  is filled
          dispatch(setsubmitDisabled(true));
        });
      }
    }, 1000);
  };
  const onVerifyPan = (): void => {
    const panNumber = form?.getFieldValue('kycPanBill');
    if (!panNumber) {
      centeredNotification('PAN Number not found');
      return;
    }
    if (panNumber.match(PANCARD_REGEX_NEW)) {
      setIsPanNumbeLoading(true);
      const payload = {
        documentType: 'Pan',
        docNumber: panNumber,
        providerId: appdetails?.getProviderId(),
      };
      dispatch(getpanVerification(payload, onPanVerificationSucess, onPanVerificationError));
    } else {
      form.setFields([
        {
          name: 'kycPanBill',
          value: '',
        }]);
    }
  };

  const onPanVerificationSucess = (): void => {
    setIsPanNumbeLoading(false);
    dispatch(setSuccessModal(true));
    dispatch(setPanVerified(true));
  };

  const onPanVerificationError = (): void => {
    setIsPanNumbeLoading(false);
    form.setFields([
      {
        name: 'kycPanBill',
        value: '',
      }]);
    dispatch(setPanField(form?.getFieldValue('kycPanBill')));
    dispatch(setPanVerified(false));

    centeredNotification(`Pan verification unsucessful for new claim creation at ${appdetails.getProviderName()} Please share correct PAN No. and try again`);
  };

  const checkRequired = (): boolean => {
    if (statesForPan?.some((ele: any): boolean => status === ele) || total > thresholdAmount) {
      return true;
    } else {
      return false;
    }
  };

  const checkVisible = (): boolean => {
    if (isPanVisibleAlways) {
      return true;

    } else if (total > thresholdAmount) {
      return true;
    } else {
      return false;
    }
  };

  useEffect((): void => {
    const panCardNo = selectedPatientDetail?.patientDetails?.panCardNo;
    if (checkVisible()) {
      if (panCardNo && isEditable) {
        form.setFieldsValue({ kycPanBill: panCardNo });
        setPanFromHIS(panCardNo);
        // Trigger the uppercase conversion and validation after setting the value
        setTimeout((): void => {
          changeToUpper();
        }, 0);
      } else if (!isEmpty(selectedPatientDetail?.patientDetails) && !panCardNo) {
        setPanFromHIS(VALUE_NOT_UPDATED);
      }
    }
  }, [checkVisible()]);

  const edit = (): any => {
    dispatch(setPanVerified(false));
  };
  const packageRadioChangeHandler = (event: any): any => {
    const selectedPackageFromRadio = event?.target?.value;
    form.setFieldsValue({ packageId: selectedPackageFromRadio });
    if (selectedPackageFromRadio) {
      const [pkgId, pkgAmt] = String(selectedPackageFromRadio).split('-');
      // TODO: Set Room : For future uses
      // const selectedPayerRoom = (payerLookUp[uniqueIdentifier]?.roomType || []).find((ele: any): boolean =>
      //   String(ele?.name).toLowerCase() === String(PAYER_ROOM_MAPPING[pkgRoom]).toLowerCase());
      // if (selectedPayerRoom) {
      //   dispatch(updateSelectedRoomType(OTHER_ID, selectedPayerRoom));
      //   dispatch(toggleOtherRoomType(true));
      //   centeredNotification(`Your selected room type has been updated to ${PAYER_ROOM_MAPPING[pkgRoom]}.`, 'info');
      // }
      const packageIndexWithDiffAmt = [...selectedPackage]?.findIndex((ele: any): any => String(ele?.packageId) === String(pkgId));
      if (packageIndexWithDiffAmt > -1) {
        const tempPkg = selectedPackage[packageIndexWithDiffAmt];
        tempPkg['packageCost'] = Number(pkgAmt);
        selectedPackage?.splice(packageIndexWithDiffAmt, 1, tempPkg);
      } else {
        const selectedPkg = packageList.find((ele: any): boolean => String(ele?.packageId) === String(pkgId));
        if (selectedPkg) {
          selectedPackage.push({
            ...selectedPkg,
            packageCost: Number(pkgAmt),
          });
        }
      }
      dispatch(updatePackageSelection([...selectedPackage]));
      const sum = getTotalSum(selectedPackage, dateOfAdmission, dateOfDischarge, dialysisVal); // changed the function to calculate sum
      form.setFieldsValue({ // based on package selected and number of dialysis
        [BILLDETAILS[0].billPackageName]: sum,  // sessions if package is related to dialysis
      });
      setPackageFieldValue(sum); // Update state to trigger total recalculation
      billDetail[0].dialysis = !!dialysisVal;
      setBillDetail(cloneDeep(billDetail));
      updatePackageValue(sum, 'Package');
      const billInfo = form.getFieldsValue(BILL_PACKAGE_NAME(isRpaPayer, shortName));
      calculateTotal(billInfo);
    }
  };
  useEffect((): any => {
    if (isPackageSelectionUpdated) {
      form.resetFields(['Package', ...(selectedPackage.map(({ packageId }: any): any => packageId))]);
      setPackageFieldValue(''); // Update state to trigger total recalculation

      calculateTotal(form.getFieldsValue(BILL_PACKAGE_NAME(isRpaPayer, shortName)));
      setIsPackageSelectionUpdated(false);
    }
  }, [isPackageSelectionUpdated, form, selectedPackage]);

  const clearPackageSelection = (): any => {
    dispatch(updatePackageSelection([]));
    selectedPackage?.forEach((ele: any): any => {
      delete billsdetail[ele?.packageId];  // clearing packageids so that on change of tab clear selection works
    });
    const packageIds = selectedPackage?.map(({ packageId }: any): any => packageId);
    form.resetFields(['Package', ...packageIds]);
    setPackageFieldValue(''); // Update state to trigger total recalculation
    setIsPackageSelectionUpdated(true); // Set flag to true
    updatePackageValue('', 'Package');
  };

  const handlePanelChange = (activeKey: any): any => {
    setIsPanelExpanded(activeKey ? 1 : 0);
  };
  const handleInputChange = (e: any, billDetailItem: any): void => {
    const numericValue = Number(e.target.value.replace(NON_NUMERIC_REGEX, ''));
    const updatedDetail = { ...billDetailItem, billAmount: numericValue };
    form.setFieldsValue({ [billDetailItem.billPackageName]: updatedDetail });
  };

  const checkDisabledPackage = (key: any): boolean => {
    if (selectedPackage?.length > 4 && shortName === 'HDFC') {
      const isPackageSelected = !selectedPackage?.some((obj: any): any => obj?.packageId === key);
      return isPackageSelected;
    } // to disable the packages 5 are selected for HDFC
    return false;
  };

  // Precompute a reverse lookup map
  const reverseFieldsMap: any = Object?.entries(BillDetailsFieldsMap).reduce(
    (acc: any, [category, fields]: any): any => {
      fields?.forEach((field: string): any => {
        acc[field] = category;
      });
      return acc;
    },
    {},
  );

  const getSuggestedValue = (fieldKey: string): string | undefined => {
    if (isEmpty(HISBillDetails)) {
      return undefined;
    }

    if (fieldKey === 'Package') {
      return HISBillDetails?.package != null
        ? formatAmount(HISBillDetails.package)
        : VALUE_NOT_UPDATED;
    }

    // Use the precomputed reverseFieldsMap for constant time
    const categoryKey = reverseFieldsMap?.[fieldKey];
    if (!categoryKey) {
      return undefined;    // for keys not in HIS response
    }
    const value = HISBillDetails[categoryKey];

    if (value == null) {  // handles both null and undefined
      return VALUE_NOT_UPDATED;
    }
    return formatAmount(value); // Return formatted amount for all values including 0
  };

    // to prefill package field if it exists in selectedPatientDetail
  useEffect((): void => {
    const hisPackageValue = HISBillDetails?.package?.toString();
    if (hisPackageValue && !isHISPackageFilled) {
      setTimeout((): void => {
        const currentPackageValue = form.getFieldValue('Package');
        // Only set if Package field is empty
        if (!currentPackageValue && !billsdetail?.Package) {
          form.setFieldsValue({
            Package: hisPackageValue,
          });
          updatePackageValue(hisPackageValue, 'Package');
          dispatch(setIsHISPackageFilled(true)); // Set flag to indicate HIS package is filled
        }
      }, 0); // Timeout to ensure form is ready
    }
  }, [HISBillDetails]);

  // Monitor Package field value changes and recalculate total
  useEffect((): void => {
    const currentPackageValue = form.getFieldValue('Package');
    if (currentPackageValue !== packageFieldValue) {
      setPackageFieldValue(currentPackageValue);
      const billInfo = form.getFieldsValue(BILL_PACKAGE_NAME(isRpaPayer, shortName));
      calculateTotal(billInfo);
    }
  }, [packageFieldValue]);

  useEffect((): void => {
    // Skip processing if any conditions are not met
    if (isEmpty(HISBillDetails) || isDetailPage || !isPanelExpanded || hasProcessedHisData.current) {
      return;
    }
    const fieldIndexMap = createBillPackageIndexMap(billDetail);
    const { updateBillDetails, indicesToDisable } = processHISBillData(HISBillDetails, fieldIndexMap, BillDetailsFieldsMap);
    // to prefill the form with HIS Values
    if (Object.keys(updateBillDetails).length) {
      form.setFieldsValue(updateBillDetails);
    }
    // to disable fields that were filled with HIS data
    if (indicesToDisable.size) {
      disableHISPopulatedFields(indicesToDisable, setBillDetail);
    }
    // to track if billDetails is already updated with HIS data
    hasProcessedHisData.current = true;
  }, [HISBillDetails, isPanelExpanded]);

  useEffect((): any => {
    if (!isEmpty(suggestedValuesMap) && formattedTotal !== undefined) {
      dispatch(setSuggestedValuesMap({
        ...suggestedValuesMap,
        claimedAmount: formattedTotal,
      }));
    }
  }, [formattedTotal]);

  return (
    <React.Fragment>
      {!collapsibleBillSection ?
        process.env.REACT_APP_IS_ENABLED_AUTOMATION_SIMULATION === 'true' &&
          Number(appService.getProviderId()) === Number(AUTOMATION_SIMULATION_HOSPITAL) &&
          payer === AUTOMATION_SIMULATION_PAYER &&
          memberId === AUTOMATION_SIMULATION_MEMBER_ID ?
          <Card title="Packages" className="bill-scroll mb-sm packageCheckboxPanel">
            {
              <FormCheckboxGroup detail={{
                ...commonDetail,
                key: 'packageCheckbox',
                options: packageList || [],
                checkBoxColSize: 24,
                hideLabel: true,
                onChange: packageChangeHandler,
              }}
              />
            }
          </Card>
          : (
            pkgTypeLoading ?
              <Skeleton active={true} paragraph={{ rows: 1 }} /> :
              <div>
                {shortName === 'HDFC' && !isDetailPage && packageList?.length > 0 &&
                  <p className="submission-warning"> Maximum of 5 packages can be selected </p>}
                {
                  (pkgSearchType === 'CHECKBOX' && !isDetailPage) &&
                  <Card title="Packages" className="bill-scroll mb-sm packageCheckboxPanel">
                    <FormCheckboxGroup detail={{
                      ...commonDetail,
                      key: 'packageCheckbox',
                      options: packageList || [],
                      checkBoxColSize: 24,
                      hideLabel: true,
                      onChange: packageChangeHandler,
                    }}
                    />
                  </Card>
                }
                {
                  (pkgSearchType === 'RADIO' && !isDetailPage) &&
                  <Card
                    title="Packages"
                    className="bill-scroll mb-sm packageCheckboxPanel"
                    extra={(<Button danger={true} type="text" onClick={clearPackageSelection}>Clear selection</Button>)}
                  >
                    {
                      packageList?.map(({
                        package_Name,
                        private_Ward,
                        semi_Private_Ward,
                        general_Ward,
                        deluxe_Other,
                        packageId,
                      }: any): ReactElement => (
                        <PackageRadioButton
                          key={packageId}
                          detail={{
                            ...commonDetail,
                            key: packageId,
                            size: 16,
                            hideLabel: true,
                            mainLabel: package_Name,
                            onChange: packageRadioChangeHandler,
                            packageDisabled: checkDisabledPackage(packageId),
                            options: [
                              { name: general_Ward, value: `${packageId}-${general_Ward}-GENERAL_WARD`, label: 'General Ward' },
                              {
                                name: semi_Private_Ward,
                                value: `${packageId}-${semi_Private_Ward}-SEMI_PVT_WARD`,
                                label: 'Semi Private Ward',
                              },
                              { name: private_Ward, value: `${packageId}-${private_Ward}-PVT_WARD`, label: 'Private Ward' },
                              { name: deluxe_Other, value: `${packageId}-${deluxe_Other}-DELUXE_OTHER`, label: 'Deluxe/Others' },
                            ],
                          }} />
                      ))
                    }
                  </Card>
                }
                {
                  (!pkgSearchType || pkgSearchType === 'SEARCH') &&
                  <Row gutter={GUTTOR_SPACE} className="bill-scroll">
                    <FormSelect
                      detail={{
                        ...commonDetail,
                        key: 'searchPackage',
                        size: 24,
                        isOptionsLoading: isPackageLoading,
                        onSearch: packageSearch,
                        onChange: packageChangeHandler,
                        options: (packageList || []),
                        customOption: CustomPackageOption,
                        mode: 'multiple',
                      }}
                    />
                  </Row>
                }
                {isBillItemsNotRequired && !selectedPackage?.length && !isDetailPage &&
                  <p className="submission-warning"> Selection of a package is mandatory to Submit a {name} claim</p>}
                {GO_DIGIT_PAYER && !isDetailPage &&
                  <p className="submission-warning"> {ATLEAST_ONE_BILL_ITEM_MESSAGE}</p>}
              </div>
          ) : <></>
      }

      <Card
        title={
          (isDetailPage || collapsibleBillSection) ? null :
            <span>
              Other Bill Details<br />
              <small className="f-100">
              {billAmountInstructionText}
              </small>
            </span>
        }
        data-testid="bill-detail"
        className="mb-sm"
      >
        {
          !isNewAdmissionPage ? <ClaimDetailHeader /> : null
        }
        {collapsibleBillSection ?
          <> <Row gutter={GUTTOR_SPACE}>
            <FormFormattedAmount
              detail={{
                ...commonDetail,
                key: 'claimedAmount',
                size: 12,
                addonBefore: '₹ ',
                allowNegative: false,
                onFocus: (): void => handleUserFocus('claimedAmount', setInputStates, true ),
                onBlur: (): void => handleUserFocus('claimedAmount', setInputStates, false ),
                isShowSuggestedValue: inputStates?.claimedAmount?.isShowSuggestedValue || false,
              }}
            />
          </Row>
            <PanelCollapse
              accordion={true}
              expandIconPosition="right"
              activeKey={isPanelExpanded}
              keyName="1"
              header="Other Bill Details (Optional)"
              fontSizeClassName="multiPayerSubPanel"
              onChange={handlePanelChange}
            >
              {billDetail.map((billDetailItem: any): any => (
                <Row key={billDetailItem.billPackageName} gutter={GUTTOR_SPACE} align="middle">
                  <Col md={24}>
                    <FormFormattedAmount
                      id={billDetailItem.billPackageName}
                      value={form.getFieldValue(billDetailItem.billPackageName)?.value || ''}
                      onChange={(e: any): any => handleInputChange(e, billDetailItem)}
                      detail={{
                        ...commonDetail,
                        key: billDetailItem.billPackageName,
                        required: false,
                        size: 24,
                        disabled: billDetailItem.disabled,
                        addonBefore: '₹ ',
                        allowNegative: false,
                        isBillDetail: true,
                        rules: [billAmountGT0Validation(billDetailItem.billPackageName),
                           billMaxAmtValidation(billDetailItem.billPackageName)],
                      }}
                      placeholder={`Enter ${billDetailItem.billPackageName.toLowerCase()}`}
                    />
                  </Col>
                </Row>
              ))}
            </PanelCollapse>
          </> :
        <Row gutter={GUTTOR_SPACE}>

          {billDetail.map(
            ({ billPackageName, billDropDownName,
              isRequired: required, disabled, dialysis, amountNotAllowed }: any, index: number): ReactElement => {
              const defaultValuePresent = Object?.keys(billDetailData[billDropDownName] || {}).length === 1 ? true : false;
              const setdefaultValue = defaultValuePresent ? Object?.keys(billDetailData[billDropDownName]) : null;
               if (GO_DIGIT_PAYER) {
                  required = false; // for GO_DIGIT_PAYER, bill detail is not required
                }
              return (
                <React.Fragment key={billPackageName}>
                  {isDropDown &&
                    <Col md={16} className="billItems">
                      <FormSelectBill
                        detail={{
                          ...commonDetail,
                          key: billDropDownName,
                          options: Object.keys(billDetailData[billDropDownName] || {}),
                          defaultValue: setdefaultValue,
                          showSearch: true,
                          required,
                          isBillDropDown: true,
                          dataTestname: billPackageName || '',
                          dataTestDrop: billDropDownName || '',
                          onChange: onSelect,
                          disabled: setdefaultValue ? true : false,
                        }} />
                    </Col>
                  }
                  <FormFormattedAmount
                    detail={{
                      ...commonDetail,
                      key: billPackageName,
                      isBillDetail: (!isDropDown),
                      required,
                      onChange,
                      disabled,
                      hideLabel: isDropDown,
                      addonBefore: '₹ ',
                      allowNegative: false,
                      size: isDropDown ? 8 : 24,
                      rules: [billAmountGT0Validation(billPackageName), billMaxAmtValidation(billPackageName)],
                      suggestedValue: getSuggestedValue(billPackageName),
                      onFocus: (): void => handleUserFocus(billPackageName, setInputStates, true),
                      onBlur: (): void => handleUserFocus(billPackageName, setInputStates, false),
                      showSuggestedValueInBillDetails: inputStates[billPackageName]?.isShowSuggestedValue || false,
                    }}
                  />
                  <Col offset={12} span={12}>
                    {dialysis && selectedPackage?.some((eachPackage: any): any => // text to be shown only if package
                      eachPackage?.package_Name?.toLowerCase()?.includes('dialysis')) ? ( // selected is related to dialysis
                      <div className="extra-message">
                        <div>{DIALYSIS_BILL_DETAIL_TEXT}</div>
                      </div>) : null}
                  </Col>
                  <Col offset={12} span={12}>
                    {
                      (amountNotAllowed && allowedRent) ? <div className="extra-message">
                        <div>
                          {getNotAllowedAmount()}
                        </div>
                      </div> : null
                    }
                  </Col>
                </React.Fragment>
              );
            },
          )}
          {
            isAdditionalFieldNeeded &&
            <Col md={12} offset={12}>
              <div className="extra-message">
                {ROOM_RENT_WITH_ADDITIONAL_FIELD_WARNING}
              </div>
            </Col>
          }
          {billDetail && billDetail?.length > 0 && !isDropDown ? <>
            <Col md={12}><div className="label-value mb-0">Total</div></Col>
            <Col md={12}>
              <div className="label-value mb-0" data-testid="total-bill">
                <NumberFormatView
                  amount={total}
                  prefix={'₹ '}
                  fixedDecimalScale={true}
                />
                <NumberFormatView
                  amount={total}
                  prefix={'₹ '}
                  fixedDecimalScale={true}
                />
              </div>
              {(isMinValidationRequired && total <= minClaimedAmountRequired) && (
                <div className="hdfc-error-message">
                  Total amount must be greater than ₹ {minClaimedAmountRequired}
                </div>
              )}
            </Col>
          </> : <>
            <div className="star-bill-total">
              <div className="label-alignment">Total</div>
              <div className="amount-alignment" data-testid="total-bill">
                <NumberFormatView amount={total} prefix={'₹ '} fixedDecimalScale={true} />
              </div>
            </div>
          </>}
        </Row>
        }
        {checkIfPOIEnabled() && process.env.REACT_APP_IS_PAN_CARD_DETAILS_ENABLED === 'true' &&
          checkVisible() && (isEditable) &&
          <><p className="mt-md">{'Please enter Patient\'s Pan Card Number'} </p>
            <div>
              <Row gutter={24}>
                <Col md={20}><FormTextInput
                  detail={{
                    ...commonDetail,
                    suffixTestId: 'form',
                    key: 'kycPanBill',
                    disabled: panVerified,
                    required: checkRequired(),
                    isBillDetail: true,
                    allowClear: false,
                    onChange: changeToUpper,
                    rules: [panValidationUploadBill],
                    suggestedValue: panFromHIS,
                    onFocus: (): any => handleUserFocus('kycPanBill', setInputStates, true),
                    onBlur: (): any => handleUserFocus('kycPanBill', setInputStates, false),
                    showSuggestedValueInBillDetails: inputStates['kycPanBill']?.isShowSuggestedValue || false,
                  }} />
                  {panVerified &&
                    <EditOutlined className="edit-icon-position" onClick={edit} />}</Col>
                <Col md={4} className={`${(!isEmpty(selectedPatientDetail) &&
                  inputStates['kycPanBill']?.isShowSuggestedValue) ? 'mt-30' : ''}`}>
                  {total > verificationAmount && verificationForPanRequired &&
                    <Button
                      disabled={panVerified}
                      onClick={onVerifyPan} loading={isPanNumberLoading}>
                      {buttonName}
                    </Button>
                  }
                </Col>
              </Row></div>
          </>
        }
        {
          <VerificationSuccessModal />
        }
        {(isDigitizationFeatureEnabled(isPatientSignEnabled) && isNewAdmissionPage)
         && <div className="margin-top-15"><ConsentPanel formValues={form} /></div>}
      </Card>
    </React.Fragment>
  );
};

export default withRouter(BillDetailCard);
